import { render } from "./qr-block-small.vue?vue&type=template&id=d4c3e46c"
import script from "./qr-block-small.vue?vue&type=script&lang=js"
export * from "./qr-block-small.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__